import { apiClient, getErrorMessage } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllSpeakingFeedback = async () => {
  try {
    const response = await apiClient.get(ENDPOINTS.SPEAKING.BASE);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSpeakingFeedbackById = async (id) => {
  try {
    const response = await apiClient.get(`${ENDPOINTS.SPEAKING.BASE}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const updateSpeakingFeedback = async (id, feedbackData) => {
  try {
    const updateData = {
      instructorFeedback: feedbackData.instructorFeedback,
      instructorAdvice: feedbackData.instructorAdvice
    };
    const response = await apiClient.put(`${ENDPOINTS.SPEAKING.BASE}/${id}`, updateData);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSpeakingResultsByRegisterId = async (registerId) => {
  try {
    const response = await apiClient.get(ENDPOINTS.SPEAKING.RESULTS_BY_REGISTER(registerId));
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAvailableSpeakingSchedule = async (examId) => {
  try {
    const response = await apiClient.get(ENDPOINTS.SPEAKING.AVAILABLE_SCHEDULE(examId));
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAvailableOnlySpeakingSchedule = async () => {
  try {
    const response = await apiClient.get(ENDPOINTS.SPEAKING.AVAILABLE_ONLY_SCHEDULE);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getPastExams = async () => {
  try {
    const response = await apiClient.get(ENDPOINTS.SPEAKING.EXAM_HISTORY);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const reserveSpeakingSchedule = async (reservationData) => {
  try {
    const response = await apiClient.put(ENDPOINTS.SPEAKING.RESERVE_SCHEDULE, reservationData);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createSpeakingMeets = async (examId, meetData) => {
  try {
    const response = await apiClient.post(ENDPOINTS.SPEAKING.CREATE_MEETS(examId), meetData);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const sendResultEmailToSomeone = async (toEmail, uprId) => {
  try {
    const response = await apiClient.post(ENDPOINTS.SPEAKING.SEND_RESULT_EMAIL(toEmail, uprId));
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
